import { Component } from "react";
import { EarthScreen } from "@/components/Earth";

export class ErrorBoundary extends Component {
  state = { err: null };
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err) { console.error(err); }
  render() {
    if (!this.state.err) return this.props.children;
    return (
      <EarthScreen testid="app-crash" title="Oops, something wilted" sub="A small part of the app stopped working. Your bookings and points are safe. Let's replant it.">
        <div className="flex w-full max-w-xs flex-col gap-2">
          <button onClick={() => window.location.reload()} data-testid="crash-reload-btn" className="h-12 rounded-2xl bg-[#0D3B2B] font-bold text-white active:scale-95 transition-transform">Reload the app</button>
          <button onClick={() => { window.location.href = "/"; }} data-testid="crash-home-btn" className="h-11 text-sm font-semibold text-[#2E9E6B]">Go to home</button>
        </div>
      </EarthScreen>
    );
  }
}
